import { createRouter, createWebHashHistory } from 'vue-router'
// import Home from '../views/Home.vue'

export default createRouter({
  history: createWebHashHistory(),
  routes: [
    {
      path: '/',
      component: () => import('../views/Home.vue'),
      children: [
        {
          name: 'error',
          path: '/',
          component: () => import('../views/Error.vue')
        },
        {
          name: 'cact1',
          path: '/cact1/:card/',
          component: () => import('../views/Cact1.vue')
        },
        {
          name: 'nCact1',
          path: '/nCact1/:card/',
          component: () => import('../views/NCact1.vue')
        },
        {
          name: 'cact2',
          path: '/cact2/:card/:applySeqNo',
          component: () => import('../views/Cact2.vue')
        },
        {
          name: 'cact3',
          path: '/cact3/:card/',
          component: () => import('../views/Cact3.vue')
        },
        {
          name: 'cact4',
          path: '/cact4/:card/',
          component: () => import('../views/Cact4.vue')
        },
        {
          name: 'cact5',
          path: '/cact5',
          component: () => import('../views/Cact5.vue')
        }
      ]
    // },
    // {
    //   name: 'error',
    //   path: '/error/',
    //   component: () => import('../views/Error.vue')
    }
  ]
})
